import lungGroup from "../../../assets/1.png"
import healthylung from "../../../assets/Healthy-lung_lifestyle _page-11.png"

export const BonusesData = [
    {
      id: 1,
      image: lungGroup,
      alt: 'lungGroup',
      link: 'https://www.facebook.com/groups/699673707101922',
    },
    {
      id: 2,
      image: healthylung,
      alt: 'healthylung',
      link: 'https://drive.google.com/file/d/1gv5d4NjE-MWRBK4C8RS8HKHThOExQmKD/view?pli=1',
    },
  ];